var map = {
	"./alerts.svg": "1439",
	"./business-green.svg": "ae9f",
	"./carbon.svg": "ea5c",
	"./connect-apps.svg": "e42d",
	"./create-free-account.svg": "ff95",
	"./doc.svg": "8aef",
	"./high-emission.svg": "dd8a",
	"./improving-finance.svg": "b7c0",
	"./no-card.svg": "c97e",
	"./secure-cloud.svg": "625b",
	"./setting.svg": "fc04",
	"./spending-analysis.svg": "5431",
	"./support.svg": "1fc9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9447";